import type { TransportType } from "@/api/types";

interface TransportConfig {
  color: string;
  label: string;
  bgClass: string;
  textClass: string;
}

export const transportConfig: Record<TransportType, TransportConfig> = {
  METRO: {
    color: "#17A544",
    label: "Metro",
    bgClass: "bg-green-600",
    textClass: "text-green-600",
  },
  BUS: {
    color: "#E4002B",
    label: "Bus",
    bgClass: "bg-red-600",
    textClass: "text-red-600",
  },
  TRAIN: {
    color: "#EC619F",
    label: "Train",
    bgClass: "bg-pink-500",
    textClass: "text-pink-500",
  },
  TRAM: {
    color: "#F9B000",
    label: "Tram",
    bgClass: "bg-yellow-500",
    textClass: "text-yellow-600",
  },
  FERRY: {
    color: "#00A5DF",
    label: "Ferry",
    bgClass: "bg-blue-500",
    textClass: "text-blue-500",
  },
  WALK: {
    color: "#6B7280",
    label: "Walk",
    bgClass: "bg-gray-500",
    textClass: "text-gray-500",
  },
};

export function getTransportConfig(type: TransportType): TransportConfig {
  return transportConfig[type] || transportConfig.WALK;
}
